import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/**
 * Ya no hay lista de eventos: cada boda vive en la ficha de su cliente. Esta
 * ruta sólo envuelve `/app/eventos/$id`, que sigue funcionando para los
 * enlaces existentes.
 */
export const Route = createFileRoute("/_authenticated/app/eventos")({
  beforeLoad: ({ location }) => {
    if (/^\/app\/eventos\/?$/.test(location.pathname)) throw redirect({ to: "/app/clientes" });
  },
  component: Outlet,
});
